/** @author PVCOMBANK */
import * as React from "react";
import { ScrollView, StyleSheet, View } from "react-native";
import { useTheme, Paragraph, Button, HelperText } from "react-native-paper";
import { Block } from "@block";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { StackActions, useNavigation } from "@react-navigation/native";
import { StackSpacing, QueueSpacing } from "@components/spacing";
import { TextInput } from "react-native-paper";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "@media-query";
import ScreenNameType from "@navigation/nav-screens";
import { useTranslation } from "react-i18next";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { StepProcessUniversal } from "app/shared/components/stepper-process/stepper-process";
import { ConvertCurrencyToVietnamese, formatNumberThousand } from "app/shared/util/format-currency";
import { useDispatch, useSelector } from "react-redux";
import { getTermDepositResponseCreatedSelector, getTermDepositOpenSelector } from "../reducer/selectors";
import { formatTextTerm, getIntRate } from "../../term-deposit-utils/term-deposit.utils";
import moment from "moment";
import { fetchTermDepositOpenConfirmRequest, setTermOpenStore } from "../reducer/actions";
import { TextInputMultiline } from "app/shared/components/form/input";
import { pushCleverTapEvent } from "app/shared/util/app-flyer";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";

const TermDepositOpenConfirm = () => {
  const { colors, fonts } = useTheme();
  const { dispatch, goBack } = useNavigation();
  const dispatchStore = useDispatch();
  const { t } = useTranslation();
  const isDesktop = useDesktopMediaQuery();
  const convertCurrencyToVietnamese = new ConvertCurrencyToVietnamese();

  const termDepositsStore = useSelector(getTermDepositOpenSelector);
  const responseCreate = useSelector(getTermDepositResponseCreatedSelector);
  const contactId = useSelector(getContactIdSelector);

  const textInputProps: object = {
    theme: { colors: { primary: colors.accent, text: colors.accent } },
    outlineColor: "transparent",
    editable: false,
  };

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        textInput: { color: colors.accent, backgroundColor: colors.backgroundForm, fontWeight: "700", textShadowColor: "black" },
        textInputAmount: { fontSize: 18 },
        buttonForm: { width: 128, alignSelf: "center", backgroundColor: colors.backgroundForm },
        desktopDisplay: { display: isDesktop ? "flex" : "none" },
        fieldFormStyles: { color: colors.text, width: 200, fontWeight: "700", fontSize: 16 },
        displayPromoCode: { display: termDepositsStore.dataCreate?.PROMO_CODE?.length ? "flex" : "none" },
      }),
    [colors, isDesktop, termDepositsStore.dataCreate],
  );

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        eventPushCleverTap(false);
        dispatch(StackActions.replace(ScreenNameType.HOME));
      },
    },
    {
      name: t("FUNC_TIET_KIEM"),
      onPressSubtitle: () => {
        eventPushCleverTap(false);
        dispatch(StackActions.replace(ScreenNameType.LIST_FUNCTION_TERM_DEPOSIT));
      },
    },
    {
      name: t("SAVING_MO_SO"),
      onPressSubtitle: () => {},
    },
  ];

  const eventPushCleverTap = (status: boolean, response?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(status, response);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const onPressCancel = () => {
    eventPushCleverTap(false);
    dispatchStore(setTermOpenStore({ ...termDepositsStore, responseCreate: undefined, isCreated: false }));
    goBack();
  };

  const onPressAccept = () => {
    eventPushCleverTap(true);
    dispatchStore(fetchTermDepositOpenConfirmRequest(responseCreate));
  };

  const handlerParamsCleverTap = (status: boolean, response?: string) => {
    console.log("handlerParamsCleverTap");
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_cta: status ? "Tiếp tục" : "Quay lại",
      ct_create_deposit_product: termDepositsStore.dataCreate?.PRODUCT?.value,
      ct_create_deposit_term: (termDepositsStore.dataCreate?.TERM?.value || "") + termDepositsStore.dataCreate?.TERM?.label,
      ct_create_deposit_amount: termDepositsStore.dataCreate?.AMOUNT,
      ct_create_deposit_maturity: termDepositsStore.dataCreate?.MATURITY?.value,
      ct_create_deposit_branch: termDepositsStore.dataCreate?.BRANCH?.value,
    };
    if (response) {
      param = {
        ...param,
        ct_create_deposit_status: response || "",
      };
    }
    return {
      eventNameCT: "ct_create_deposit_confirm",
      paramsCT: param,
    };
  };
  /// MARK: - Bussiness Logic HERE

  ///

  const FieldForm = ({ name = "" }) => (
    <View style={styles.desktopDisplay}>
      <StackSpacing size="medium" />
      <Paragraph style={styles.fieldFormStyles}>{name}</Paragraph>
      <StackSpacing size="medium" />
    </View>
  );

  const FormAccountHolder = (
    <Block ph={isDesktop ? spacing.galactic : spacing.large} row={isDesktop ? true : false} pt={spacing.medium}>
      <FieldForm name={t("TRANFER_TAI_KHOAN_NGUON")} />
      <Block flex={1} bg={colors.backgroundForm} br={12} p={spacing.large}>
        <TextInput
          {...textInputProps}
          style={styles.textInput}
          label={t("TRANFER_TAI_KHOAN_NGUON")}
          value={termDepositsStore.dataCreate?.ACCOUNT_DEBIT?.ACCOUNTNO}
        />
        <TextInput
          {...textInputProps}
          style={styles.textInput}
          label={t("ACC_SO_DU_KHA_DUNG")}
          value={formatNumberThousand(termDepositsStore.dataCreate?.ACCOUNT_DEBIT?.AVAILABLEBALANCE)}
          right={<TextInput.Affix textStyle={fonts.regular} text={t("COMMON_VND")} />}
        />
      </Block>
    </Block>
  );

  const FormConfirm = (
    <Block ph={isDesktop ? spacing.galactic : spacing.large} row={isDesktop ? true : false} pt={spacing.large}>
      <FieldForm name={t("TOPUP_DICH_VU")} />
      <Block flex={1} bg={colors.backgroundForm} br={12} p={spacing.large}>
        <TextInput
          {...textInputProps}
          style={styles.textInput}
          label={t("SAVING_SAN_PHAM")}
          value={termDepositsStore.dataCreate?.PRODUCT?.label}
        />
        <TextInput
          {...textInputProps}
          style={[styles.textInput, styles.textInputAmount]}
          label={t("SAVING_SO_TIEN")}
          value={formatNumberThousand(responseCreate?.EBACCOUNT_DEPOSITS?.TRANSACTION_AMOUNT)}
          right={<TextInput.Affix textStyle={fonts.regular} text={t("COMMON_VND")} />}
        />
        <HelperText type="info" visible={true} style={{ color: colors.accent }}>
          {convertCurrencyToVietnamese.convert(Number(responseCreate?.EBACCOUNT_DEPOSITS?.TRANSACTION_AMOUNT || 0))}
        </HelperText>
        <Block row={isDesktop ? true : false} flex={1}>
          <Block flex={isDesktop ? 1 : undefined}>
            <TextInput
              {...textInputProps}
              style={styles.textInput}
              label={t("SAVING_KY_HAN")}
              value={formatTextTerm(termDepositsStore.dataCreate?.TERM?.value, termDepositsStore.dataCreate?.TERM?.label)}
            />
          </Block>
          <QueueSpacing size="huge" />
          <Block flex={isDesktop ? 1 : undefined}>
            <TextInput
              {...textInputProps}
              style={styles.textInput}
              label={t("SAVING_LAI_SUAT")}
              value={getIntRate(responseCreate?.ACCOUNTPROFILE?.INTRATE) + " % / " + t("COMMON_NAM").toLowerCase()}
            />
          </Block>
        </Block>

        <Block row={isDesktop ? true : false} flex={1}>
          <Block flex={isDesktop ? 1 : undefined}>
            <TextInput
              {...textInputProps}
              style={styles.textInput}
              label={t("SAVING_NGAY_MO_SO")}
              value={moment(String(responseCreate?.EBACCOUNT_DEPOSITS?.OPEN_DATE), "YYYYMMDD").format("DD/MM/YYYY")}
            />
          </Block>
          <QueueSpacing size="huge" />
          <Block flex={isDesktop ? 1 : undefined}>
            <TextInput
              {...textInputProps}
              style={styles.textInput}
              label={t("SAVING_NGAY_DAO_HAN")}
              value={moment(String(responseCreate?.EBACCOUNT_DEPOSITS?.MATURITY_DATE), "YYYYMMDD").format("DD/MM/YYYY")}
            />
          </Block>
        </Block>
        <TextInputMultiline
          name="SAVING_HINH_THUC_DAO_HAN"
          {...textInputProps}
          style={styles.textInput}
          label={t("SAVING_HINH_THUC_DAO_HAN")}
          value={termDepositsStore.dataCreate?.MATURITY?.label}
        />
        <TextInputMultiline
          name="SAVING_CHI_NHANH_QUAN_LY_SO"
          {...textInputProps}
          style={styles.textInput}
          label={t("SAVING_CHI_NHANH_QUAN_LY_SO")}
          value={termDepositsStore.dataCreate?.BRANCH?.label}
        />
        {termDepositsStore.dataCreate?.PROMO_CODE?.length ? (
          <TextInput
            {...textInputProps}
            style={[styles.textInput, styles.displayPromoCode]}
            label={t("SAVING_PROMO_CODE")}
            value={termDepositsStore.dataCreate?.PROMO_CODE}
          />
        ) : (
          <></>
        )}
      </Block>
    </Block>
  );

  const ButtonRow = (
    <Block row middle pv={spacing.huge}>
      <Block w={isDesktop ? 200 : 0} />
      <Button onPress={onPressCancel} mode="contained" style={styles.buttonForm}>
        {t("COMMON_QUAY_LAI")}
      </Button>
      <QueueSpacing size="large" />
      <Button onPress={onPressAccept} mode="contained">
        {t("COMMON_TIEP_TUC")}
      </Button>
    </Block>
  );

  React.useEffect(() => {
    if (termDepositsStore.isConfirm) {
      eventPushCleverTap(true, "success");
      dispatch(StackActions.replace(ScreenNameType.TERM_DEPOSIT_OPEN_AUTH));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, termDepositsStore.isConfirm]);

  React.useEffect(() => {
    if (termDepositsStore.statusConfirm === "error") {
      eventPushCleverTap(true, "failure" + (termDepositsStore.errorMsg || ""));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [termDepositsStore.statusConfirm]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("SAVING_MO_SO")} subtitles={subtitlesArrays} />
        <StepProcessUniversal currentSteps={1} />
        {FormAccountHolder}
        {FormConfirm}
        {ButtonRow}
      </ScrollView>
    </Block>
  );
};

export default TermDepositOpenConfirm;
